import { useState, useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Menu from "../Menubar/Menu";
import { Linien } from "./Linien";
import './Linien.css';
import Streckenverlauf from "../Infrastruktur/Streckenverlauf";
import { Categories } from "../MainMenu/MenüSicht";
import { Linienführung } from "../Linienführung/Linienführung";
import NeueLinienführung from "../Linienführung/NeueLinienführung/NeueLinienführung";
var MonitorApi = require('monitor-api');

export default function MainLinie ({ myApiClient, setSection }) {
    const location = useLocation();
    const navigate = useNavigate();

    var linienInstance = new MonitorApi.LinieApi(myApiClient);
    var linienVerlInstance = new MonitorApi.LinienverlaufApi(myApiClient);
    var vmInstance = new MonitorApi.VerkehrsmittelApi(myApiClient);
    var absInstance = new MonitorApi.AbschnittApi(myApiClient);
    let tgZuJahrInstance = new MonitorApi.TagesgruppeZuJahrApi(myApiClient);
    var strInstance = new MonitorApi.StreckeApi(myApiClient);
    var strVerlInstance = new MonitorApi.StreckenverlaufApi(myApiClient);
    var bhfInstance = new MonitorApi.BahnhofApi(myApiClient);

    const [selected, setSelected] = useState();

    useEffect(() => {
        setSection('Linien & Strecken');
    }, [setSection]);


    useEffect (() => {
        const steps = location.pathname.split('/');
        if (steps[steps.length - 1] !== "linien-und-strecken") {
            console.log('gibt eine Weiterleitung!')
            setSelected(steps[steps.length - 1]);
        } else {
            setSelected(""); //zum Zurücksetzen bei Verlinkung nach Speichern eines neuen Verlaufs
        }
    }, [location.pathname])
    
    const selectCat = event => {
        event.preventDefault();
        navigate(`../linien-und-strecken/${event.target.value}`, {replace: true});
    }
    return (
        <div className="next-to-menu">
            <Menu/>
            {/* <p>
                ..Menüpunkt in Bearbeitung..
            </p> */}
            <Categories>
                <h1>Verwaltung von Linien &#38; Infrastruktur</h1>
                <section className={selected ? "ls-collection" : "ls-collection placeholder"}>
                    <button value={'liniendaten'} className={selected === 'liniendaten' ? "ls-bttn ls-bttn-active" : "ls-bttn"} 
                        onClick={selectCat}>Linien</button>
                    <button value={'linienführung'} className={selected === 'linienführung' ? "ls-bttn ls-bttn-active" : "ls-bttn"} 
                        onClick={selectCat}>Linienführung</button>
                    <button value={'linienführung-anlegen'} className={selected === 'linienführung-anlegen' ? "ls-bttn ls-bttn-active" : "ls-bttn"} 
                        onClick={selectCat}>&#43; neue Linienführung</button>
                    <button value={'strecken'} className={selected === 'strecken' ? "ls-bttn ls-bttn-active" : "ls-bttn"} 
                        onClick={selectCat}>Infrastruktur</button>
                </section>
            <section className={selected ? "container" : "empty-container"}>
                <Routes>
                    <Route path={`/liniendaten`} element={<Linien instance={linienInstance} vmInstance={vmInstance}/>} />
                    <Route path={`/linienführung`} element={<Linienführung linienInstance={linienInstance} jahrInstance={tgZuJahrInstance} linienVerlInstance={linienVerlInstance} />} />
                    <Route path={`/linienführung-anlegen`} element={<NeueLinienführung linienInstance={linienInstance} linienVerlInstance={linienVerlInstance} bhfInstance={bhfInstance} strVerlInstance={strVerlInstance} strInstance={strInstance}/>} />
                    <Route path={`/strecken`} element={< Streckenverlauf strVerlInstance={strVerlInstance} bhfInstance={bhfInstance} strInstance={strInstance} absInstance={absInstance} />} />
                </Routes>
            </section>
            </Categories>
           
        </div>
    )
}
